import DOMPurify from 'dompurify'

export const safeHtml = {
  mounted(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value ?? '')
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = DOMPurify.sanitize(binding.value ?? '')
    }
  }
}
